module.exports = __webpack_public_path__ + "static/media/alcohol.9c0d9e76.svg";